import { createSlice } from "@reduxjs/toolkit";
import { fetchAllSymbolParams } from "../thunks/symbolGroup";


const symbolSlice = createSlice({
  name: "symbol",
  initialState: {
    selectedSymbol: {},
    symbolDetails: null,
    allSymbols: [],
    allSymbolParams: {},
    loading: false,
    error: null,
    bid: null,
    ask: null,
    orderResponse: null,
    parentId: null,
    symbolParameters: null,
  },

  reducers: {
    setSymbol(state, action) {
      const { symbolId, symbolName, bid, ask, parentId } = action.payload;
      state.selectedSymbol = { symbolId, symbolName };
      state.bid = bid;
      state.ask = ask;
      state.parentId = parentId;
    },
    setSymbolId: (state) => {
      state.selectedSymbol = {};
      state.symbolDetails = null;
      state.bid = null;
      state.ask = null;
      state.parentId = null;
    },
    setOrderResponse(state, action) {
      state.orderResponse = action.payload;
    },
    clearOrderResponse(state) {
      state.orderResponse = null;
    },
    setSymbolParameters(state, action) {
      state.symbolParameters = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllSymbolParams.fulfilled, (state, action) => {
      state.allSymbolParams = action.payload
    })

  }

});

export const { setSymbol, setSymbolId, setOrderResponse, clearOrderResponse, setSymbolParameters } =
  symbolSlice.actions;
export default symbolSlice.reducer;
